var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12,
    fill: "#ECF0F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8355 8.96012L13.2964 12.5001L16.8355 16.0402C17.0548 16.2596 17.0548 16.6163 16.8355 16.8357C16.7252 16.946 16.5812 17 16.4373 17C16.2933 17 16.1493 16.9449 16.039 16.8357L12.5 13.2957L8.96097 16.8357C8.85073 16.946 8.70674 17 8.56275 17C8.41876 17 8.27476 16.9449 8.16452 16.8357C7.94516 16.6163 7.94516 16.2596 8.16452 16.0402L11.7035 12.5001L8.16452 8.96012C7.94516 8.74069 7.94516 8.38399 8.16452 8.16457C8.38388 7.94514 8.74048 7.94514 8.95985 8.16457L12.4989 11.7046L16.0379 8.16457C16.2573 7.94514 16.6139 7.94514 16.8332 8.16457C17.0526 8.38399 17.0526 8.74069 16.8332 8.96012H16.8355Z",
    fill: "#9DB2CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.827695fb75a6cecde99dfee3616745e8.svg";
export { ForwardRef as ReactComponent };